export const invoiceProjectsState = {
  invoiceProjects: null,
  invoiceProjectDetails: [],
};